module.exports = __webpack_public_path__ + "img/8fbe516bdc3286e8a443f9822c881316.svg";